import { SET_FILE_STORAGE, SET_FILES, CLEAR_FILE_STORAGE } from './fileStorageTypes';

export const setFileStorage = (fileStorage) => ({
    type: SET_FILE_STORAGE,
    payload: fileStorage
});

export const setFiles = (files) => ({
    type: SET_FILES,
    payload: files
});

export const clearFileStorage = () => ({
    type: CLEAR_FILE_STORAGE
});